import apiClient from "../../common/apiClient.js";

export default class EncryptionController {
  async EncryptDecryptOrHashText(token, data) {
    try {
      // const response = 
      return await apiClient.post(
        "/encryption",
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // return response;
    } catch (error) {
      return error;
    }
  }
}
